import { render } from "./noUseClient.vue?vue&type=template&id=60dd5ad9&scoped=true"
import script from "./noUseClient.vue?vue&type=script&lang=js"
export * from "./noUseClient.vue?vue&type=script&lang=js"

import "./noUseClient.vue?vue&type=style&index=0&id=60dd5ad9&lang=scss&scoped=true&rel=stylesheet%2Fscss"
import "./noUseClient.vue?vue&type=style&index=1&id=60dd5ad9&lang=css"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dd5ad9"]])

export default __exports__